import script from "./superadmin-login.vue?vue&type=script&setup=true&lang=js"
export * from "./superadmin-login.vue?vue&type=script&setup=true&lang=js"

import "./superadmin-login.vue?vue&type=style&index=0&id=a65255a6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a65255a6"]])

export default __exports__